import type { AssetColors } from './asset-colors.js';

export const LIGHT_ASSETS: AssetColors = {
  giwa: '#555555',
  thatch: '#d8b848',
  evergreenLight: '#8dd88d',
  evergreenDark: '#3d6a4d',
  trunk: '#7a5030',
  pine: '#358025',
  leaf: '#4a9e35',
  bush: '#40882a',
  roofA: '#d05a3a',
  roofB: '#daa055',
  wall: '#f0e8d0',
  wallShade: '#d0c498',
  church: '#f0e8d8',
  fence: '#b09a68',
  wheat: '#dac040',
  sheep: '#f5f5f0',
  sheepHead: '#444',
  cow: '#9a6e45',
  cowSpot: '#fff',
  chicken: '#daa835',
  whale: '#4580aa',
  whaleBelly: '#90bcd0',
  boat: '#9a7848',
  sail: '#fff',
  fish: '#60a0b8',
  flag: '#dd3838',
  windmill: '#d8c898',
  windBlade: '#eee',
  well: '#8a7a55',
  chimney: '#9a7a55',
  path: '#b8a078',
  water: '#4578aa',
  waterLight: '#65a0cc',
  deer: '#9a7038',
  horse: '#7e5430',
  flower: '#f07090',
  flowerCenter: '#ffe050',
  mushroom: '#f0e8d8',
  mushroomCap: '#d05040',
  rock: '#909090',
  boulder: '#7a7a7a',
  palm: '#55a030',
  willow: '#609840',
  seagull: '#f0f0f0',
  dock: '#8a7050',
  tent: '#d8c898',
  tentStripe: '#dd5555',
  hut: '#b09870',
  market: '#e8d8a8',
  marketAwning: '#dd6644',
  inn: '#d8b888',
  innSign: '#e4b050',
  blacksmith: '#666666',
  anvil: '#555555',
  castle: '#b0b0b0',
  castleRoof: '#707090',
  tower: '#a0a0a0',
  bridge: '#9a8a6a',
  cart: '#9a7a50',
  barrel: '#8a6a38',
  torch: '#7a6038',
  torchFlame: '#ffaa33',
  cobble: '#989888',
  smoke: 'rgba(160,160,160,0.35)',
  bird: '#555555',
  scarecrow: '#9a8050',
  scarecrowHat: '#6a5030',
  stump: '#7a5a30',
  riverOverlay: 'rgba(60,130,210,0.55)',
  pondOverlay: 'rgba(50,120,200,0.60)',
  reeds: '#7a9848',
  fountain: '#a0a0a0',
  fountainWater: '#80b8e0',
  canal: '#8a8a7a',
  gardenTree: '#55aa45',
  ricePaddy: '#9aba58',
  ricePaddyWater: '#5a98c0',
  // New 118-type expansion colors
  jellyfish: '#b080d8',
  coral: '#e07868',
  turtle: '#6a9858',
  buoy: '#dd5555',
  lighthouse: '#f0e8d8',
  crab: '#d07040',
  driftwood: '#9a8060',
  sandcastle: '#e8d8a0',
  tidePools: '#6aa0c0',
  heron: '#b0b8c0',
  shellfish: '#d0b890',
  cattail: '#7a9848',
  frog: '#5a9838',
  lily: '#f098b0',
  rabbit: '#c0b0a0',
  fox: '#d07a38',
  butterfly: '#e080b0',
  butterflyWing: '#f0b050',
  beehive: '#d0b050',
  wildflower: '#e070e0',
  tallGrass: '#6aa848',
  birchBark: '#f0e8d8',
  haybale: '#d0b858',
  owl: '#9a8060',
  squirrel: '#b07040',
  moss: '#5a8a38',
  fern: '#4a9838',
  deadTree: '#7a6a50',
  log: '#8a6a40',
  berryBush: '#4a8838',
  berry: '#dd4040',
  spiderWeb: 'rgba(180,180,180,0.45)',
  silo: '#b0b0b0',
  pig: '#f0b8b0',
  trough: '#8a7a60',
  haystack: '#d8b848',
  orchard: '#55a038',
  orchardFruit: '#dd5540',
  beeFarm: '#d8c070',
  pumpkin: '#e08030',
  tavern: '#b09870',
  tavernSign: '#9a7838',
  bakery: '#d8b888',
  stable: '#9a8060',
  gardenFence: '#f0e8d0',
  laundry: '#f0e8f0',
  doghouse: '#9a7040',
  shrine: '#b0b0b8',
  wagon: '#9a7850',
  cathedral: '#d0c8b8',
  cathedralWindow: '#5090d0',
  library: '#c0b098',
  clocktower: '#b0b0b0',
  clockFace: '#f8f0d8',
  statue: '#a0a0a8',
  parkBench: '#7a6a50',
  warehouse: '#9a9088',
  gatehouse: '#b0a898',
  manor: '#d8c8a8',
  manorGarden: '#55a048',
  signpost: '#8a7050',
  lantern: '#7a6a50',
  lanternGlow: '#ffd850',
  woodpile: '#8a6a40',
  puddle: '#6a98c8',
  campfire: '#7a6038',
  campfireFlame: '#ff7733',
  // Seasonal: Winter
  snowCap: '#f0f4f8',
  snowGround: '#e4ecf4',
  ice: '#b0d0e8',
  icicle: '#c0e0f8',
  frozenWater: '#70a0c8',
  igloo: '#e8f0f8',
  sledWood: '#9a6a38',
  sledRunner: '#708090',
  scarfRed: '#dd4040',
  snowmanCoal: '#333333',
  snowmanCarrot: '#f08030',
  winterBirdRed: '#dd4040',
  winterBirdBrown: '#9a7050',
  firewoodLog: '#7a5030',
  bareBranch: '#7a6a5a',
  frostWhite: '#eef4f8',
  // Seasonal: Spring
  cherryPetalPink: '#f8b0c8',
  cherryPetalWhite: '#fce8f0',
  cherryTrunk: '#7a5040',
  cherryBranch: '#8a6050',
  tulipRed: '#f05060',
  tulipYellow: '#f8e050',
  tulipPurple: '#a060d0',
  tulipStem: '#6aaa50',
  sproutGreen: '#90e060',
  nestBrown: '#8a6540',
  eggBlue: '#b8e8f0',
  eggWhite: '#f8f4e8',
  crocusPurple: '#9050c0',
  crocusYellow: '#f0d838',
  lambWool: '#f8f4ed',
  birdhouseWood: '#b08050',
  gardenSoil: '#6a5040',
  // Seasonal: Summer
  parasolRed: '#f05050',
  parasolBlue: '#5090e0',
  parasolYellow: '#f0d030',
  parasolStripe: '#ffffff',
  beachTowelA: '#f06060',
  beachTowelB: '#50a0e0',
  sandcastleWall: '#e8d0a0',
  surfboardBody: '#f0f0f0',
  surfboardStripe: '#f05050',
  iceCreamCart: '#f8f0e0',
  iceCreamUmbrella: '#f05050',
  hammockFabric: '#e0a060',
  sunflowerPetal: '#f8d030',
  sunflowerCenter: '#6a4a30',
  watermelonRind: '#50b050',
  watermelonFlesh: '#f05050',
  watermelonSeed: '#333333',
  lemonadeStand: '#f8e890',
  sprinklerMetal: '#90a0b0',
  poolWater: '#70c8f0',
  poolEdge: '#d0d8e0',
  // Seasonal: Autumn
  mapleRed: '#d84030',
  mapleCrimson: '#b03030',
  mapleOrange: '#e08030',
  oakGold: '#d8b040',
  oakBrown: '#9a7040',
  birchYellow: '#e8d050',
  ginkgoYellow: '#e8d840',
  fallenLeafRed: '#d05040',
  fallenLeafOrange: '#e09040',
  fallenLeafGold: '#e0b040',
  fallenLeafBrown: '#9a6a40',
  acornBody: '#9a7040',
  acornCap: '#6a4830',
  cornStalkColor: '#d8b870',
  cornEar: '#e8d070',
  harvestApple: '#d84040',
  harvestGrape: '#7040b0',
  hotDrinkMug: '#d8b070',
  hotDrinkSteam: '#e0e8f0',
  wreathGreen: '#608048',
  wreathBerry: '#d04040',
  // Extended Seasonal: Autumn
  autumnGold: '#e0b85c',
  autumnBronze: '#c08840',
  autumnBurgundy: '#9b3050',
  autumnRust: '#d06540',
  autumnOlive: '#9b9b50',
  // Extended Seasonal: Spring
  blossomPink: '#ffc6d1',
  blossomWhite: '#fff8fb',
  peachPink: '#ffe5dc',
  // Extended Seasonal: Winter
  icicleBlue: '#e0f0ff',
  christmasRed: '#d42e4a',
  christmasGold: '#ffe720',
  christmasGreen: '#32a032',
  // Fruit Trees
  appleRed: '#d42e4a',
  oliveGreen: '#909070',
  oliveFruit: '#5a5a40',
  lemonYellow: '#ffff5f',
  orangeFruit: '#ff9c10',
  pearGreen: '#e1f241',
  peachFruit: '#ffdbb4',
  // Additional Livestock
  donkey: '#909090',
  goat: '#f0e8e0',
  goatHorn: '#c0b0a0',
  // Enhanced asset detail colors
  shadow: '#4a4a5e',
  bushDark: '#3d6a4d',
  leafLight: '#8dd88d',
  flowerAlt: '#f8b0d0',
  // Epic building colors
  epicGold: '#ffe740',
  epicMarble: '#f0e8d8',
  epicJade: '#3aad6a',
  epicCrystal: '#90e8ff',
  epicMagic: '#b070d0',
  epicPortal: '#20e8e0',
};
